<template>
    <div class="addcontract">
        <header class="text-xs-center white--text">
            <h2>Gesellschaft wählen</h2>
            <p>Wählen Sie über die Suche Ihre Versicherungsgesellschaft:</p>

            <v-flex xs12 sm6 offset-sm3 mb-3>
                <v-text-field 
                  solo 
                  append-icon="search" 
                  v-model="model" 
                  hint="Geben Sie die gesuchte Gesellschaft hier einfach ein ..."
                  persistent-hint
                  class="light-hint"
                  :loading="loading"
                ></v-text-field>
            </v-flex>
        </header>

        <section class="mb-3">
            <v-layout row>
                <v-flex xs12>
                    <v-card v-if="model.length>1 && isMobile || !isMobile" class="pl-2">
                        <v-list>
                            <template v-for="(category, key, index) in items_categorized">
                                <v-subheader class="mt-3" :key="index">{{ category[0].name[0].toUpperCase() }}</v-subheader>

                                <v-divider :key="index" :inset="true"></v-divider>

                                <v-list-tile v-for="(item) in category" :key="item.id" avatar @click="openDialog(item)">
                                    <v-list-tile-avatar :tile="true">
                                        <img :src="item.logo_url" alt="" />
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="item.name"></v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-btn icon><v-icon color="primary">navigate_next</v-icon></v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </template>
                            <template v-if="show_add_insurance">
                                <v-subheader>Unbekannt</v-subheader>
                                <v-divider :inset="true"></v-divider>
                                <v-list-tile class="unknownlisttile" @click="new_insurance = model;show_form_add_insurance = true">
                                    <v-list-tile-avatar class="pt-3">
                                        <v-icon>add</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Gesellschaft nicht dabei?</v-list-tile-title>
                                        <v-list-tile-sub-title>Sie haben Ihre gesuchte Gesellschaft nicht gefunden? Dann fügen Sie diese einfach hier hinzu!</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <v-bottom-sheet v-model="show_form_add_insurance" lazy inset>
            <v-card class="pa-3" tile>
                <v-form ref="form_add_insurance" lazy-validation @submit.prevent="add_insurance">
                    <v-layout row wrap justify-center>
                        <v-text-field
                            ref="new_insurance"
                            type="text"
                            v-model="new_insurance"
                            :rules="[() => !!new_insurance || 'Pflichtfeld - Bitte ausfüllen', () => !!new_insurance && new_insurance.length >= 3 || 'Die Gesellschaft muss aus mindestens 3 Zeichen bestehen']"
                            label="Gesellschaft *"
                            maxlength="36"
                            clearable
                            required
                        />
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="show_form_add_insurance = false">Abbrechen</v-btn>
                        <v-spacer />
                        <v-btn color="black" @click="add_insurance" dark>Hinzufügen und weiter</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>


        <v-dialog v-model="dialog" width="700">
            <v-card class="text-xs-center pb-3">
                <v-card-title class="headline" primary-title style="justify-content: center;">Vertrag hinzufügen</v-card-title>
                <v-card-text>
                    <p>Wählen Sie aus zwei Methoden den Vertrag bei VAPP anzulegen: manuell hinzufügen oder VAPP kostenfrei beauftragen und die Arbeit machen lassen.</p>
                    <v-layout row wrap>
                        <v-flex xs12 md6 class="px-1 my-2">
                            <v-card light hover @click="contractnk_dialog = true">
                                <div v-if="$store.state.mandate.url" class="pa-3">
                                    <div class="headline mb-2">VAPP beauftragen</div>
                                    <div>
                                        <p>Sie müssen nichts weiter tun. VAPP organisiert zukünftig alle aktuellen Daten und Dokumente zu Ihrem Vertrag.</p>
                                    </div>
                                </div>
                                <div v-else class="pa-3">
                                    <div class="headline mb-2">Vertrag hinzufügen lassen</div>
                                    <div>
                                        <p>VAPP organisiert alle aktuellen Daten und Dokumente zu Ihrem Vertrag (automatische Aktualisierung).</p>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md6 class="px-1 my-2">
                            <v-card light hover @click="handmade_dialog = true">
                                <div class="pa-3">
                                    <div class="headline mb-2">Vertrag selbst hinzufügen</div>
                                    <div>
                                        <p>Vertrag selbst anlegen, verwalten und Dokumente hochladen (automatische Aktualisierung nicht möglich).</p>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog v-model="handmade_dialog" absolute max-width="700">
            <v-form ref="handmade_form" v-model="handmade_valid" lazy-validation @submit.prevent="addcontract">
                <v-card>
                    <v-card-title class="headline">Vertrag manuell erfassen</v-card-title>
                    <v-card-text class="contract-overview-box inline-contractcard-box">
                        <v-card>
                            <v-layout>
                                <v-flex class="text-xs-center" xs0 sm3>
                                    <v-avatar size="75px" :title="contract.productpartner.name">
                                        <img v-if="contract.productpartner.logo_url" :src="contract.productpartner.logo_url" :alt="contract.productpartner.name" class="img-fluid" />
                                        <v-icon v-else>{{ contract.product.icon }}</v-icon>
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs12 sm9>
                                    <v-card-title primary-title>
                                        <div class="w-100">
                                            <h3 class="headline text-truncate">{{ contract.kind }}</h3>
                                            <div v-if="contract.product.name" class="pt-3">{{ contract.product.name ? contract.product.description : this.$route.params.kind }}</div>
                                        </div>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-card-text>
                    <v-card-text>
                        <p>Für die Verwaltung Ihrer Versicherung bitte noch folgendes angeben:</p>
                        <v-layout row wrap class="py-2">
                            <v-flex xs12 md6 class="pr-2">
                                <v-text-field
                                v-model="contract.vertragsnummer"
                                type="text"
                                name="vertragsnummer"
                                :rules="[rules.required, rules.min, rules.maxlen60]"
                                label="Vertragsnummer *"
                                clearable
                                />
                            </v-flex>
                            <v-flex xs12 md6 class="pl-2" style="position:relative;">
                                <v-text-field
                                  v-model="contract.person_name" 
                                  type="text" 
                                  name="person_name"
                                  label="Versicherungsnehmer" 
                                  disabled
                                />
                                <div class="anothervnlink" @click="anothervnl_tmpsave = contract.person_name; show_form_anothervnl = true">nicht zutreffend?</div>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="py-2">
                            <v-flex xs12 md6 class="pr-2">
                                <v-text-field
                                v-model="contract.beginn_date"
                                type="date"
                                name="beginn_date"
                                :rules="[rules.required]"
                                label="Vertragsbeginn *"
                                clearable
                                required
                                />
                            </v-flex>
                            <v-flex xs12 md6 class="pl-2">
                                <v-select
                                :items="['Lastschrift', 'Rechnung']"
                                v-model="contract.zahlungsart"
                                name="zahlungsart"
                                label="Zahlungsart *"
                                required
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="py-2">
                            <v-flex xs12 md6 class="pr-2">
                                <v-text-field
                                v-model="contract.beitrag"
                                type="number"
                                append-icon="euro_symbol"
                                step="0.01"
                                name="beitrag"
                                :rules="[rules.required]"
                                label="Beitrag *"
                                clearable
                                required
                                />
                            </v-flex>
                            <v-flex xs12 md6 class="pl-2">
                                <v-select
                                :items="['monatlich', 'vierteljährlich', 'halbjährlich', 'jährlich']"
                                v-model="contract.beitrag_intervall_name"
                                name="beitrag_intervall_name"
                                label="Beitragsintervall"
                                hint="Das Intervall der Bezahlung des angegebenen Betrages"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="(contract.kind.search(/haftpflicht/i)>=0 || contract.kind=='Inhaltsversicherung')" row wrap class="py-2">
                            <v-flex xs12 md6 class="pr-2">
                                <v-text-field
                                v-model="contract.selbstbeteiligung"
                                type="number"
                                append-icon="euro_symbol"
                                step="0.01"
                                name="selbstbeteiligung"
                                label="Selbstbeteiligung"
                                hint="Bis zu welcher Summe müssen Sie im Schadensfall selbst aufkommen?"
                                clearable
                                />
                            </v-flex>
                            <v-flex xs12 md6 class="pl-2">
                                <v-text-field
                                v-model="contract.versicherungssumme"
                                type="number"
                                append-icon="euro_symbol"
                                step="0.01"
                                name="versicherungssumme"
                                label="Versicherungssumme"
                                hint="Die maximale Schadensabdeckung"
                                clearable
                                />
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn flat @click="handmade_dialog = false">Zurück</v-btn>
                        <v-spacer />
                        <v-btn color="black" dark @click="addcontract">{{ ($route.fullPath.search('check')>=0) ? `Vergleich erhalten` : `Vertrag speichern` }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="contractnk_dialog" absolute max-width="700">
            <v-form ref="contractnk_form" v-model="contractnk_valid" lazy-validation @submit.prevent="addcontract">
                <v-card>
                    <v-card-title class="headline">Vertragsnummer hinzufügen</v-card-title>
                    <v-card-text class="contract-overview-box inline-contractcard-box">
                        <v-card>
                            <v-layout>
                                <v-flex class="text-xs-center" xs0 sm3>
                                    <v-avatar size="75px" :title="contract.productpartner.name">
                                        <img v-if="contract.productpartner.logo_url" :src="contract.productpartner.logo_url" :alt="contract.productpartner.name" class="img-fluid" />
                                        <v-icon v-else>{{ contract.product.icon }}</v-icon>
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs12 sm9>
                                    <v-card-title primary-title>
                                        <div class="w-100">
                                            <h3 class="headline text-truncate">{{ contract.kind }}</h3>
                                            <div v-if="contract.product.name" class="pt-3">{{ contract.product.name ? contract.product.description : this.$route.params.kind }}</div>
                                        </div>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-card-text>
                    <v-card-text>
                        <p>Für den automatischen Abgleich von Vertragsdaten und Dokumente bitte die Vertragsnummer angeben.<br/><b>Tipp</b>: Sie finden diese am schnellsten über Ihr Online-Banking Konto!</p>
                        <v-layout row wrap class="py-2">
                            <v-flex xs12 sm6 class="px-1">
                                <v-text-field
                                v-model="contract.vertragsnummer"
                                type="text"
                                name="vertragsnummer"
                                :rules="[rules.required, rules.min, rules.maxlen60]"
                                label="Vertragsnummer *"
                                clearable
                                />
                            </v-flex>
                            <v-flex xs12 sm6 class="px-1" style="position:relative;">
                                <v-text-field
                                  v-model="contract.person_name" 
                                  type="text" 
                                  name="person_name"
                                  label="Versicherungsnehmer" 
                                  disabled
                                />
                                <div class="anothervnlink" @click="anothervnl_tmpsave = contract.person_name; show_form_anothervnl = true">nicht zutreffend?</div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn flat @click="contractnk_dialog = false">Zurück</v-btn>
                        <v-spacer />
                        <v-btn color="black" dark @click="setContractNK">Vertrag speichern</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog id="mandatnfo_dialog" v-model="mandatnfo_dialog" persistent absolute max-width="700">
            <v-card>
                <v-card-title class="headline">Empfehlung: Vollmacht erteilen</v-card-title>
                <v-card-text>
                    <p>Damit wir für Sie tätig werden dürfen und Sie unseren kostenfreien VAPP-Service nutzen können, beispielsweise die automatische Aktualisierung der Vertragsdaten und Dokumente, erteilen Sie uns einfach eine Vollmacht.</p>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 class="pr-1">
                            <p>
                                <v-icon class="color-green" left>check</v-icon> kostenfreier Service<br/>
                                <v-icon class="color-green" left>check</v-icon> auto. Synchronisierung<br/>
                                <v-icon class="color-green" left>check</v-icon> alle Vertragsdokumente
                            </p>
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-1">
                            <p>
                                <v-icon class="color-green" left>check</v-icon> Preis-Leistungscheck 1x Jahr<br/>
                                <v-icon class="color-green" left>check</v-icon> 1 Login - 1 Ansprechpartner<br/>
                                <v-icon class="color-green" left>check</v-icon> Direkter Schadenservice
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="black" dark to="/mandate">Maklervertrag erstellen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-bottom-sheet v-model="show_form_anothervnl" persistent lazy inset max-width="500">
            <v-card class="pa-3" tile>
                <v-form ref="form_anothervnl" @submit.prevent="show_form_anothervnl = false">
                    <p>Wie lautet der Versicherungsnehmer für diesen Vertrag?</p>
                    <v-layout row wrap justify-center>
                        <v-text-field
                            ref="contract.person_name_anothervnl"
                            v-model="contract.person_name"
                            maxlength="60"
                            :rules="[rules.required, rules.maxlen60]"
                            label="Versicherungsnehmer*"
                            @keydown.enter="show_form_anothervnl = false"
                            clearable
                            required
                        />
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="show_form_anothervnl = false; contract.person_name = anothervnl_tmpsave; anothervnl_tmpsave = '';">Abbrechen</v-btn>
                        <v-spacer />
                        <v-btn color="black" dark @click="show_form_anothervnl = false; contract.person_type = 'dritte';">Person verwenden</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>

    </div>
</template>

<script>
import { API_URL_BASE, IS_MOBILE } from '@/constants.js'

export default {
  data: () => ({
    type: null,
    product: null,
    model: '',
    items: [],
    items_categorized: [],
    show_form_anothervnl: false,
    anothervnl_tmpsave: '',
    show_form_add_insurance: false,
    show_add_insurance: true,
    new_insurance: '',
    persons: [],

    dialog: false,
    contract: {
        kind: '',
        productpartner_id: null,
        vertragsnummer: '',
        versicherungssumme: '',
        beginn_date: '',
        beitrag: '',
        zahlungsart: 'Rechnung',
        selbstbeteiligung: '',
        beitrag_intervall_name: 'monatlich',
        is_mandate: 0,
        product: {},
        productpartner: {}
    },
    rules: {
        required: value => !!value || 'Pflichtfeld - Bitte ausfüllen',
        min: v => (v || '').length >= 6 || 'Geben Sie mindestens 6 Zeichen ein',
        maxlen60: v => (v || '').length <= 60 || 'Geben Sie nur maximal 60 Zeichen ein',
        email: v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
        }
    },

    handmade_dialog: false,
    handmade_valid: false,
    contractnk_dialog: false,
    mandatnfo_dialog: false,
    contractnk_valid: false,
    loading: true
  }),


  watch: {
      model(val){
            if(val.length>=1){
                var index = this.customFilter(this.items, val);
                this.items_categorized = this.categorizeItBaby(index);
            }else{
                this.items_categorized = this.categorizeItBaby(this.items);
            }
      }
  },

  computed: {
      isMobile(){
        return IS_MOBILE();
      }
  },


    methods: {
        customFilter(objList, text){
            if(undefined === text || text === '' ){
                return objList;
            }
            return objList.filter(product => product.name.toLowerCase().indexOf(text.toLowerCase()) != -1 );
        },

        add_insurance(){
            this.openDialog({id: null, name: this.new_insurance, logo_url: '', type: this.contract.product.type ? this.contract.product.type : 'insurance'});
        },

        categorizeItBaby(items){
            let i = 0
            let lastletter = ''
            let bla = []
            var tmp = items;
            bla[0] = [];
            tmp.forEach(function (item, index) {
                let l = _.deburr(item.name.charAt(0)).toUpperCase();
                //console.log(index, item.name);
                if (lastletter !== l) {
                    lastletter = l
                    i++
                    bla[i] = []
                }
                bla[i].push(item)
            })
            return _.tail(bla)
        },

        addcontract () {
            if(this.$refs.handmade_form.validate()){
                this.addContractBlind();
            }
        },

        openDialog (company) {
            this.contract.productpartner = company;
            this.dialog = true;
        },

        setContractNK(){
            this.contract.is_mandate = 1;
            this.addContractBlind();
        },

        addContractBlind(){
            if(!_.isEmpty(this.contract.beitrag)){
                this.contract.beitrag_netto = (this.contract.beitrag / 1.19).toFixed(2);
            }
            this.$store.dispatch('contracts/addContract', this.contract).then(newContract => {
                if(this.contract.product.icon=='find_in_page'){
                    this.$store.dispatch('chat/sendAdminMail', {
                        subject: `Produkt nicht gefunden von ${this.$store.getters['user/getDisplayName'](false)}`,
                        content1: `Der Kunde: ${this.$store.getters['user/getDisplayName'](true, this.type)}) hat für seinen Vertrag ${this.contract.productpartner.name} ${this.contract.kind} mit der Vertragsnummer: ${this.contract.vertragsnummer ? this.contract.vertragsnummer : '/'} das Produkt: "${this.$route.params.kind}" nicht gefunden und somit händisch hinterlegt.`,
                        kind: `UNKNOWN_PRODUCT`,
                        heading: `Unbekanntes Produkt: ${this.$route.params.kind}`,
                        cid: newContract.id
                    });
                }
                this.$snotify.success('Vertrag wurde erfolgreich hinzugefügt');
                if(this.contract.is_mandate==1 && !this.$store.state.mandate.url){
                    this.mandatnfo_dialog = true;
                }else{
                    this.$router.push({ path: '/contract/all' });
                }
            });
        },

        getEmptyProduct(){
            this.contract.product = {
                name: this.contract.kind,
                icon: 'find_in_page',
                type: 'insurance',
                description: 'Noch unbekanntes Produkt.'
            };
        }
    },


    mounted: function () {
        this.type = this.$route.params.type;
        this.product_id = this.$route.params.product;
        this.contract.kind = this.$route.params.kind;
        this.contract.type = this.$route.params.type;
        if(!_.isEmpty(this.product_id)){
            let tmp = this.$store.getters['products/getAllProducts'];
            if(tmp.length<5){
                this.$store.dispatch('products/loadProductData').then(products => {
                    this.contract.product = this.$store.getters['products/getProductFromID'](this.product_id);
                    if(!this.contract.product){
                        this.getEmptyProduct();
                    }
                });
            }else{
                this.contract.product = this.$store.getters['products/getProductFromID'](this.product_id);
                if(!this.contract.product){
                    this.getEmptyProduct();
                }
            }
        }else{
            this.getEmptyProduct();
        };
        // console.log('contract.product :>> ', this.contract.product);
        this.contract.person_type = this.$route.params.type;
        this.contract.person_name = this.$store.getters['user/getDisplayName'](false, this.type);
        let tmp = this.$store.getters['products/getAllCompanies'];
        if(tmp.length<5){
            this.$store.dispatch('products/loadProductpartnerData').then(companies => {
                this.items = this.$store.getters['products/getCompaniesFromCat'](this.contract.product.type);
                this.items_categorized = this.categorizeItBaby(this.items);
                this.loading = false;
            });
        }else{
            this.items = this.$store.getters['products/getCompaniesFromCat'](this.contract.product.type);
            this.items_categorized = this.categorizeItBaby(this.items);
            this.loading = false;
        }
        this.$vuetify.goTo(0);

        if(this.type=='private'){
            this.persons.push('Ich selbst');
            this.$store.getters['persons/getPersonsByRelationship']('FA').forEach((person, index) => {
                this.persons.push(`${person.forename} ${person.surname}`);
            });
        }else{
            this.persons.push('Unternehmen');
            this.$store.getters['persons/getAllPersons'].forEach((person, index) => {
                if(person.relationship!='FA'){
                    this.persons.push(`${person.forename} ${person.surname}`);
                }
            });
        }
    }
}
</script>


<style>
    .unknownlisttile>.v-list__tile{
        height: auto;
        padding: 1rem;
    }
    .unknownlisttile>.v-list__tile .v-list__tile__sub-title{
        white-space: inherit;
        max-height: inherit;
    }

    @media screen and (max-width: 768px) {
        #mandatnfo_dialog{
            text-align: center;
        }
        #mandatnfo_dialog .flex>p{
            margin:0!important;
        }
    }

    @media screen and (max-width: 576px) {
        .v-card .layout{
            flex-direction: column;
            text-align: center;
        }
        .v-card .layout > .xs0{
            padding-top: 16px;
        }
        .contract-overview-box .v-avatar .v-icon {
            font-size: 5rem;
        }
    }
</style>